import PropTypes from 'prop-types'
import { useState } from 'react'
import Moment from 'react-moment'
import { noop } from 'utils'
import RestrictionIpUpdate from 'features/restrictionIp/RestrictionIpUpdate'
import { Modal } from 'components/dialog/Modals'
import NoneAnchor from 'components/NoneAnchor'

const RestrictionIpItem = ({ data: { id, ip, description, enrollDate } }) => {
  const [updateOn, setUpdateOn] = useState(false)

  return (
    <>
      <td>
        <div className="inner_tbl">
          <Moment format="YYYY.MM.DD HH:mm">{enrollDate}</Moment>
        </div>
      </td>
      <td>
        <div className="inner_tbl">{ip}</div>
      </td>
      <td>
        <div className="inner_tbl">
          {description}
          <NoneAnchor className="link_g" onClick={() => setUpdateOn(!updateOn)}>
            <span className="ico_comm ico_modify">수정</span>
          </NoneAnchor>
          <Modal
            on={updateOn}
            className="iplimit_layer"
            onBackgroundClick={() => false}>
            <RestrictionIpUpdate
              id={id}
              currentDescription={description}
              handleClose={() => setUpdateOn(!updateOn)}
            />
          </Modal>
        </div>
      </td>
    </>
  )
}

export default RestrictionIpItem

RestrictionIpItem.propTypes = {
  data: PropTypes.shape({
    enrollDate: PropTypes.string.isRequired,
    ip: PropTypes.string.isRequired,
    id: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
  }),
  onChange: PropTypes.func,
  onModify: PropTypes.func,
}

RestrictionIpItem.defaultProps = {
  onModify: noop,
  onChange: noop,
}
